module.exports = __webpack_public_path__ + "img/service_light_normal.59460048.svg";